import { Col, Drawer, Row,} from "antd";
import ListItems from "./Components/ListItems";
import Search from "./Components/Search";
import { useGetInvoices } from "./ServerSideStates";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useState } from "react";
import MazakaDetailsFilterButton from "apps/Common/MazakaDetailsFilterButton";
import { handleResetInvoiceFitler } from "./ClientSideStates";
import MazakaClearFilters from "apps/Common/MazakaClearFilters";
import DetailsFilter from "./Components/DetailsFiilter";

import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";

const InvoiceIndex = () => {
  const { filter } = useSelector((state: RootState) => state.invoice);
  const invoices = useGetInvoices(filter);
  const [isShowFilterDetailsDrawer, setIsShowFilterDetailsDrawer] =
    useState(false);
  return (
    <>
      <Col xs={24}
      className="!p-0"
      >
        <Row 
         gutter={[
          { xs: 10, md:10 , xl:10 }, 
          { xs:10 , md: 15, xl:20}   
        ]}
        
        className="">
          <Col xs={12} md={24} className="!flex justify-start md:justify-center">
          <Helmet>
                        <title className="capitalize">{"Faturalarım"}</title>
                      </Helmet>
            <PageTitle
              title="Faturalarım"
              count={invoices?.data?.data?.filteredCount || "0"}
            />
          </Col>
          <Col xs={12} md={24} className="!flex justify-end gap-3">
            {Object.entries(filter).length > 5 && (
              <>
                <MazakaClearFilters resetFunc={handleResetInvoiceFitler} />
              </>
            )}
            
            <MazakaDetailsFilterButton
              setIsShowDetailsFilter={setIsShowFilterDetailsDrawer}
            />
          </Col>

          <Col xs={24} className="">
            <Row>
              <Col xs={24} className="!bg-[#fafafa] !p-2">
                <Row>
                  <Col xs={24} lg={4}>
                    <Search />
                  </Col>
                </Row>
              </Col>
              <Col xs={24}>
                <ListItems />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Drawer
        title="Detaylı Filtre"
        open={isShowFilterDetailsDrawer}
        onClose={() => {
          setIsShowFilterDetailsDrawer(false);
        }}
      >
        <>
          {isShowFilterDetailsDrawer && (
            <DetailsFilter
              onFinish={() => {
                setIsShowFilterDetailsDrawer(false);
              }}
            />
          )}
        </>
      </Drawer>
    </>
  );
};

export default InvoiceIndex;
